module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-nav-wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('comb.myVoiceTag')))])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("选择您擅长的作品类型并根据试音文稿上传试音小样作为您的声音标签。通过审核后，我们将自动向您推荐该类型的演播邀约。优秀的声音标签将增大我们向您推荐的几率。"), _c('router-link', {
    staticStyle: {
      "color": "#fc5832",
      "text-decoration": "underline"
    },
    attrs: {
      "to": {
        name: 'fastMissionIntro'
      }
    }
  }, [_vm._v("了解更多")])], 1), _vm._v(" "), _c('span', {
    staticClass: "sub-title",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("您最多可以上传3个声音标签")])]), _vm._v(" "), _c('div', {
    staticClass: "tag-list-wrapper"
  }, [_vm._l((_vm.tags), function(tag, index) {
    return (tag.auditStatus === 9) ? _c('div', {
      staticClass: "tag-item"
    }, [_c('span', [_vm._v(_vm._s(tag.categoryLabel))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteTag(tag.tagId, index)
        }
      }
    }, [_vm._v("删除标签")])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.tags), function(tag) {
    return (tag.auditStatus !== 9) ? _c('div', {
      staticClass: "tag-item-auditing"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "title-wrapper"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(tag.categoryLabel))]), _vm._v(" "), _c('div', {
      staticClass: "attachment-wrapper"
    }, [_c('i', {
      staticClass: "icon icon-18 icon-upload mr10"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": tag.audioUrl,
        "download": "voice"
      }
    }, [_vm._v(_vm._s(tag.audioName))])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNewTag),
      expression: "isShowNewTag"
    }],
    staticClass: "new-tag"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("请选择一个你擅长的类型")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "props": _vm.props,
      "expand-trigger": "hover",
      "show-all-levels": false,
      "options": _vm.options,
      "placeholder": "选择擅长分类"
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.tagId),
      callback: function($$v) {
        _vm.tagId = $$v
      },
      expression: "tagId"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("请上传一个你的试读声音，我们将会审核")]), _vm._v(" "), _c('div', {
    staticClass: "download-content",
    class: {
      'disabled': _vm.contentUrl === ''
    }
  }, [_c('i', {
    staticClass: "icon icon-18 icon-check-audio mr10"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showAuditionContent(_vm.contentUrl)
      }
    }
  }, [_vm._v("查看试读选段(" + _vm._s(_vm.tagName) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "upload-audio"
  }, [_c('i', {
    staticClass: "icon icon-18 icon-upload"
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "before-upload": _vm.beforeUpload,
      "on-progress": _vm.uploadProgress,
      "on-success": _vm.uploadSuccess,
      "action": "/dtres/audio/upload",
      "show-file-list": false,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "text"
    }
  }, [_vm._v("上传试读作品")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.audioName))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.saveTag
    }
  }, [_vm._v("提交")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNewTagLoading),
      expression: "isNewTagLoading"
    }],
    staticClass: "cover"
  }, [_c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.progress
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "new-tag-btn",
    on: {
      "click": _vm.showNewTag
    }
  }, [_vm._v("添加标签")])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "size": "tiny"
    },
    model: {
      value: (_vm.isShowHelp),
      callback: function($$v) {
        _vm.isShowHelp = $$v
      },
      expression: "isShowHelp"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "text-align": "center"
    }
  }, [_vm._v("主播等级达到v4及以上才能参加海选，查看"), _c('a', {
    staticStyle: {
      "color": "#fc5832"
    },
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/c/anchor/help/center/anchorLevelTips")
    }
  }, [_vm._v("如何提升")]), _vm._v("自己的主播等级。")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowHelp = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "close-on-click-modal": false,
      "top": "30%"
    },
    model: {
      value: (_vm.isShowAuditionContent),
      callback: function($$v) {
        _vm.isShowAuditionContent = $$v
      },
      expression: "isShowAuditionContent"
    }
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line",
      "word-break": "break-word",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.auditionContent))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-status"
  }, [_c('span', [_vm._v("审核中")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c372f96!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/center/MyVoiceTag.vue
// module id = 538
// module chunks = 0